import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/images/FariaHabibLogo.jpg";

const navLinks = [
  { label: "Home", href: "#home", key: "home" },
  { label: "Skills", href: "#skills", key: "skills" },
  { label: "Projects", href: "#projects", key: "projects" },
  { label: "Research", href: "#research", key: "research" },
  { label: "Background", href: "#achievements", key: "achievements" },
  { label: "Blogs", href: "#blogs", key: "blogs" },
  { label: "Contact", href: "#contact", key: "contact" },
];

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="/">
          <img src={logo} alt="Faria Habib" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {navLinks.map((link) => (
              <Nav.Link
                key={link.key}
                href={link.href}
                className={activeLink === link.key ? "active navbar-link" : "navbar-link"}
                onClick={() => setActiveLink(link.key)}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
